import Firebase from 'firebase/app'
import { initializeApp } from 'firebase'
import 'firebase/firestore'

const app = initializeApp({
  apiKey: 'AIzaSyClqqZESkgay1FAEiiGpH78UKhNOXcbIuE',
  authDomain: 'loja-ilha-teste.firebaseapp.com',
  databaseURL: 'https://loja-ilha-teste.firebaseio.com',
  projectId: 'loja-ilha-teste',
  storageBucket: 'loja-ilha-teste.appspot.com',
  messagingSenderId: '631723298564',
  appId: '1:631723298564:web:bcbf723b77c115ab3a0a51'
})

const { Timestamp, GeoPoint } = Firebase.firestore
const db = app.firestore()
db.enablePersistence({ synchronizeTabs: true })
export { db, app, Timestamp, GeoPoint }



// WEBPACK FOOTER //
// ./src/firebase.js